import { useTranslation } from 'react-i18next';
import React from "react";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { useAllocModel } from "../inventoryStatisticsModel";


export function PageHeader() {
    const { t } = useTranslation();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAllocModel();
    const searchFields = [
        {
            type: 'Select',
            placeholder: t(`stock.view.PageHeader.是否积压`),
            fieldName: "overstockFlag",
            options: [{ label: t(`stock.view.PageHeader.是`), value: 1 }, { label: t(`stock.view.PageHeader.否`), value: "0" }],
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.商品编码`),
            fieldName: "materialCode"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.商品名称`),
            fieldName: "materialName"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.替换编号`),
            fieldName: "replaceCode"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.货位`),
            fieldName: "shelfCode",
        },
    ]


    return (
        <YhPageHeader
            title={t(`stock.view.PageHeader.销存率统计`)}
            size="small"
            justify="end"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData(undefined, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}